import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/image/logo.png";
import Sidebar from "./Sidebar";

const Header = ({ showButton = true }) => {
  const [state, setState] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const navigation = [
    { title: "دروس تدریس شده", path: "/lectures" },

    { title: "نمونه سوالات", path: "/training" },
    { title: "درباره ما", path: "/team" },
    {
      path: "/about",
      title: "ارتباط با ما",
    },
  ];

  return (
    <nav className="sticky top-0 z-30 w-full px-1 py-1 bg-white sm:px-2 shadow">
      <div className="items-center px-4 max-w-screen-xl mx-auto md:flex md:px-5">
        <div className="flex items-center justify-between py-2 md:py-2 md:block">
          <Link to="/">
            <img src={Logo} width={80} height={80} alt="Float UI logo" />
          </Link>
          <div className="md:hidden">
            <button
              className="text-gray-700 outline-none p-2 rounded-md focus:border-gray-400 focus:border"
              onClick={() => setState(!state)}
            >
              {state ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 8h16M4 16h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
        <div
          className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
            state ? "block" : "hidden"
          }`}
        >
          <ul className="justify-start items-center space-y-8 md:flex md:space-x-6 md:space-y-0">
            {navigation.map((item, idx) => {
              return (
                <li
                  key={idx}
                  className="text-gray-600 hover:text-indigo-600 md:m-4"
                >
                  <Link to={item.path}>{item.title}</Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="hidden md:inline-block">
          {showButton && (
            <button
              onClick={() => setShowSidebar(!showSidebar)}
              className="py-3 px-4 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md shadow"
            >
              دیدن مباحث
            </button>
          )}
        </div>
        <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      </div>
    </nav>
  );
};

export default Header;
